import { render, staticRenderFns } from "./MsgContent.vue?vue&type=template&id=73a17474&scoped=true&"
import script from "./MsgContent.vue?vue&type=script&lang=js&"
export * from "./MsgContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a17474",
  null
  
)

export default component.exports